import { render, staticRenderFns } from "./conjoined.vue?vue&type=template&id=44637577"
import script from "./conjoined.vue?vue&type=script&lang=js"
export * from "./conjoined.vue?vue&type=script&lang=js"
import style0 from "./conjoined.vue?vue&type=style&index=0&id=44637577&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports